
/* eslint-disable @typescript-eslint/no-unused-vars */
import { defineComponent } from "vue";
import ProfileMenu from "./ProfileMenu.vue";
import Notifications from "./Notifications.vue";
import { useMenuStore } from "@/stores/menu";
import { sharpIcon } from "@/utils/sharpIcon";

export default defineComponent({
  components: { ProfileMenu, Notifications },
  name: "dashboard-topbar",
  props: ["menuName"],
  data() {
    return {
      name: this.menuName,
    };
  },
  computed: {
    menuStore() {
      return useMenuStore();
    },
    menuInfo() {
      return this.menuStore.getMenuItemForRoute(
        this.name as string,
        this.$route
      );
    },
  },
  watch: {
    $route(to, from) {
      this.name = this.$route.name;
    },
  },
  methods: {
    sharpIcon,
  },
});
